import React from 'react';
import { Package, TrendingUp, AlertTriangle, BarChart3 } from 'lucide-react';

const Inventory: React.FC = () => {
  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-primary-100 rounded-lg">
          <Package className="w-6 h-6 text-primary-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Inventory Management</h1>
          <p className="text-gray-600">Track stock levels, manage suppliers, and monitor inventory</p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Package className="w-8 h-8 text-gray-400" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Coming Soon</h2>
        <p className="text-gray-600 mb-4">
          Inventory Management features are currently under development. This module will include:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
          <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
            <Package className="w-5 h-5 text-gray-500" />
            <span className="text-sm text-gray-700">Stock Level Tracking</span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
            <TrendingUp className="w-5 h-5 text-gray-500" />
            <span className="text-sm text-gray-700">Purchase Orders</span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
            <AlertTriangle className="w-5 h-5 text-gray-500" />
            <span className="text-sm text-gray-700">Low Stock Alerts</span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
            <BarChart3 className="w-5 h-5 text-gray-500" />
            <span className="text-sm text-gray-700">Inventory Reports</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inventory;
